import { STAFF_ROLES } from "./roles";

const STAFF_ROLES_LOWER = new Set(STAFF_ROLES.map((r) => r.toLowerCase()));

/**
 * Role string for messaging contact lists. Course enrollment can be "alumno" while
 * the platform role is staff (e.g. director also enrolled as student); prefer platform
 * role for display so staff is not mislabeled as alumno.
 */
export function contactRoleLabelForDisplay(contacto) {
  if (!contacto || typeof contacto !== "object") {
    return "";
  }
  const global = String(contacto.rolGlobal ?? contacto.rol ?? "").trim();
  const curso = String(contacto.rolCurso ?? "").trim();
  const globalLc = global.toLowerCase();
  const cursoLc = curso.toLowerCase();
  if (
    cursoLc === "alumno" &&
    globalLc !== "" &&
    STAFF_ROLES_LOWER.has(globalLc)
  ) {
    return global;
  }
  if (curso !== "") {
    return curso;
  }
  return global;
}
